<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
                <el-breadcrumb-item>考勤日报</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id' highlight-current default-expand-all>
                    <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                        <span :title="node.label" class="">{{data.name}}</span>
                    </span>
                </el-tree>
            </div>
            <div class="main-table">
                <div class="hight-pie1" id="pie1"></div>
                <div v-if="showNoData" style="position: absolute;left: 50%;top: 30%;">暂无数据</div>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import HighCharts from 'highcharts'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],
            defaultProps:{
                children: 'list',
                 label: 'name'
            },
            teamSeach:{
                date:util.myTime.getCurTime(),
                teamsName:'',
                sortings:'1',//当前排序
                projectId:'',
            },
            //projectId:'',
            //entId:'',
            opt:{
                projectId:'',
                joinType:'',
                entId:'',
                date:util.myTime.getCurTime()
            },
            showNoData:false,
        }
    },
    mounted(){
        util.common.filterBtnMenu('')
        var port = util.session.get('roleId')
        this.groupId = util.session.get('groupId')
        this.getTreeData()
        // this.getPerson()
    },
    methods:{
        //获取左边树形
        getTreeData(){
            var that = this
            myHttp.getPageListPro({
                entId:this.groupId,
                levelType:3
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entOfficeProjectMenu||[]
                    var curKey = ''
                    // var projectEntId = ''
                    if(list.length>0){
                        for(var i=0;i<list.length;i++){
                            for(var j=0;j<list[i].list.length;j++){
                                // list[i].list[j].parentId = list[i].id
                                if(curKey==''){
                                    curKey = list[i].list[j].projectId ||list[i].list[j].id
                                }
                                for(var k=0;k<list[i].list[j].list.length;k++){
                                    list[i].list[j].list[k].parentId = list[i].list[j].id
                                }
                            }
                        }
                    }
                    that.dataTree = list
                    that.opt.projectId = curKey
                    // that.joinEntId = projectEntId
                    that.getData()
                    setTimeout(function(){
                      that.$refs.tree.setCurrentKey(curKey)
                    },100)
                }
            })
        },

        //根据id获取名称
        getTypeName(id){
            var list = this.entsTypes
            var result = ''
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].value) {
                    result = list[i].label
                }
            }
            return result
        },
        //查询参建数据
        entFilter(){
            this.getJoinEnt()
        },
        /***
         * 获取班组
         */
        getData(){
            var that = this
            myHttp.getAttendProjectEntNew(this.opt).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    var data = [[],[]]
                    var team = []
                    for(var i=0;i<list.length;i++){
                        if(list[i].zzCount>0){
                            data[0].push(list[i].zzCount)
                            data[1].push(list[i].cqCount)
                            team.push(list[i].teamsName)
                        }
                    }
                    //that.teams = list
                    that.setChart(data,team)
                    that.showNoData = false
                }else{
                    that.showNoData = true
                }
            })
        },
        /**
         * 点击
         */
        handleNodeClick(e){
            console.log(e)
            if(e.level=='1'){
                this.opt.projectId = ''
                this.opt.entId = ''
            }else if(e.level=='2'){
                this.opt.projectId = e.id
                this.opt.entId = ''
            }else{
                this.opt.projectId = e.parentId
                this.opt.entId = e.id
            }
            this.getData()
        },
        /**
         * 柱状图
         */
        setChart(data,teams){
            HighCharts.chart('pie1',{
                chart: {
                    type: 'bar'
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                xAxis: {
                    categories: teams,
                    title: {
                        text: null
                    },
                    labels:{
                        style:{
                            fontSize:'20'
                        }
                    },
                },
                yAxis: {
                    min: 0,
                    allowDecimals: false,
                    title: {
                        text: '单位 (人)',
                        align: 'high'
                    },
                    labels: {
                        overflow: 'justify'
                    }
                },
                tooltip: {
                    valueSuffix: ''
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            allowOverlap: true, // 允许数据标签重叠
                            y:2,
                        }
                    }
                },
                series: [{
                    name: '在职',
                    color: '#D8E4F9',
                    data: data[0],
                    pointPadding: 0.3, // 通过 pointPadding 和 pointPlacement 控制柱子位置
                    pointPlacement: -0.15,
                    dataLabels: {
                        enabled: true,
                        align: 'right',
                        format: '在职人数：{point.y:.0f}', // :.1f 为保留 1 位小数
                        y:6,
                        x:12000
                    }
                }, {
                    name: '出勤',
                    color: '#5C95FA',
                    data: data[1],
                    pointPadding: 0.3, // 通过 pointPadding 和 pointPlacement 控制柱子位置
                    pointPlacement: 0.15,
                    dataLabels: {
                        enabled: true,
                        color:'#000',
                        align: 'right',
                        format: '出勤：{point.y:.0f}', // :.1f 为保留 1 位小数
                        y:6,
                        x:-10000,
                    }
                }]
            })
        },
    }

}
</script>
<style scoped>
    
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        /* overflow: auto; */
        background: #fff;
        border-radius: 0.5vh;
        padding: 1vh 0;
        overflow: auto;
    }
    .main-left-search{
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vh;
    }
    .main-left-p{
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content:space-between;
        padding: 0 1vh;
    }
    .main-left-list{
        width: 100%;
        height: 90%;
        position: relative;
        overflow: auto;
    }
    .main-left-list li{
        width: 100%;
        height: 15%;
        position: relative;
        padding: 2vh;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }
    .main-left-list li:hover{
        background: #eee;
    }
    .curEnt{
        background: #E7F1FB;
    }
    .unit-type{
        width: 20%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-items: center;
        align-content: center;
        border: 1px solid #0365F2;
        padding: 1.5%;
    }
    .unit-name{
        width: 70%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        align-content: center;
        padding-left: 1vh;
        flex-wrap: wrap;
    }
    .unit-name p{
        width: 100%;
        text-align: left;
    }
    .main-table{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
    }
    .table-head{
        width: 100%;
        height: 6vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 2vh;
        justify-content: space-between;
    }
    .table-head-seach{
        width: 20%;
        height: 100%;
        position: relative;
    }
    .table-box{
        width: 100%;
        /* height: calc( 100% - 17vh ); */
        height: 100%;
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
    }
    .box-ent{
        width: 100%;
        height: 10vh;
        position: relative;
        margin-bottom: 1vh;
        background: #fff;
        border-radius: 5px;
        display: flex;
        /* flex-wrap: wrap; */
    }
    .box-ent-l{
        width: 80%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 2vh;
        align-content: center;
        align-items: center;
    }
    .box-ent-l p{
        width: 33%;
        height: 3vh;
        position: relative;
        text-align: left;
        padding-right: 1vh;
    }
    .box-ent-r{
        width: 20%;
        height: 100%;
        display: flex;
        align-content: center;
        align-items: center;
        margin-right: 20px;
        justify-content: flex-end
    }
    .hight-pie1{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
    }
</style>
<style>
    @import '../../assets/css/common.css';
    .el-tree-node__content{
        height: 30px;
    }
    .el-tree-node__label{
        font-size: inherit;
    }
</style>